import './App.css';
import { ThemeProvider } from 'styled-components';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import { ReactQueryDevtools } from 'react-query/devtools';
import { RemoteConfigProvider } from 'context/RemoteConfigContextProvider';
import { ModalProvider } from 'context/ModalProviderContext';

import { FirebaseAuthProvider } from './context/FirebaseContextProvider';
import Routes from './navigation/Router';
import { GlobalModal } from './context/GlobalModal';
import { theme } from './theme';
import { ContainerStyle, ToastOptions } from './types';
import { config, EnvironmentType } from './config';

const queryClient = new QueryClient();

export const ENVIRONMENT = process.env.NODE_ENV as EnvironmentType;

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <Toaster position="top-right" containerStyle={ContainerStyle} toastOptions={ToastOptions} />
        <GlobalModal>
          <FirebaseAuthProvider>
            <RemoteConfigProvider>
              <ModalProvider>
                <Routes />
              </ModalProvider>
            </RemoteConfigProvider>
          </FirebaseAuthProvider>
        </GlobalModal>
      </ThemeProvider>
      {config.ENVIRONMENT === EnvironmentType.DEVELOPMENT && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>
  );
}

export default App;
